import { useState, useCallback } from "react";
import { signUp } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

interface SignUpInput {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  salonName?: string;
  autoNavigate?: boolean;
  license?: string;
}

const useSignUpUser = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = useCallback(
    async ({ email, password, firstName, lastName, salonName, autoNavigate , license }: SignUpInput) => {
      try {
        setLoading(true);
        const user = await signUp({
          username: email,
          password: password,
          options: {
            userAttributes: {
              email,
              name: firstName,
              family_name: lastName,
            },
            autoSignIn: true,
          },
        });

        if (user?.userId) {
        

          if (autoNavigate) {
            toast.success("Account created successfully!", {
              description: "Please check your email for verification.",
            });
            navigate("/email-verification", {
              state: {
                email,
                firstName,
                lastName, 
                salonName,
                userId: user?.userId,
                license,
                role: "buyer",
              },
            });
          }
        }

        return user;
      } catch (error: any) {
        if (error.message === "User already exists") {
          console.error("User already exists:", error);
          toast.error("User with this email already exists.", {
            description: "Please use a different email address.",
          });
        } else {
          toast.error("Error creating account", {
            description: error?.message || "An error occurred. Please try again.",
          });
          console.error("SignUp Error:", error);
        }
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return {
    handleSignUp,
    loading,
  };
};

export default useSignUpUser;
